import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { documentsLoader } from './documents-loader';

export const documentsRoutes: RouteObject = {
  loader: documentsLoader,
  children: [
    {
      path: '/documents',
      lazy: lazyComponent(
        () => import('@pages/client/document/documents-page'),
        'DocumentsPage',
      ),
    },
  ],
};
